/**
 * OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPage
 *
 * Page component for OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPage
 * Path: /sl/docs/core-concepts/patterns
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPatternsSLDocScreenView as __OrbDocCoreConceptsPatternsSLDocScreenView } from '@/components/traits/OrbDocCoreConceptsPatternsSLDocScreenView';
import { OrbDocCoreConceptsPatternsSLDocAnalyticsView as __OrbDocCoreConceptsPatternsSLDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPatternsSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPage(_props: OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Vzorci vmesnika","description":"Kaj zna narisati render-ui: drevo registriranih vzorcev, vezano na entiteto.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/patterns"},{"locale":"ar","path":"/ar/docs/core-concepts/patterns"},{"locale":"sl","path":"/sl/docs/core-concepts/patterns"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPatternsSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPatternsSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPatternsSLOrbDocCoreConceptsPatternsSLPage;
